import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { formatImage } from '../../../../base/publicMethod/index';
import { getImageUrl, imageAttr } from '../utils/image';
import formatTimeLength from '../utils/formatTimeLenth';
import styles from '../styles/styles.css';
import imageUrl from './imageUrl';
import { handleCallNewsApp, h5PageCount } from '../../../../utils';

/* 二图模式 */
class TwoImage extends PureComponent {
    static propTypes = {
        item: PropTypes.object,
        url: PropTypes.string,
        isLazyImage: PropTypes.bool,
    };

    handleClick = (url, id, newstype, kind, clickCountConfig, downloads = {}) => {
        const nodata = '';
        const doc_type = newstype;
        const aid = id;
        const to_url = url;

        this.feedClickCountFn(clickCountConfig);

        handleCallNewsApp(nodata, doc_type, aid, to_url, 0, 0, kind, {}, downloads);
    };

    feedClickCountFn = config => {
        if (config) {
            h5PageCount([config]);
        }
    };

    render() {
        const { url, item, isLazyImage } = this.props;
        const { title, thumbnails, id, callUp, newstype, length, clickCount, kind, hasVideoIcon, downloads } = item;
        const image = thumbnails.image;
        const width = imageAttr(340);
        const height = imageAttr(188);
        const src = formatImage(getImageUrl(image[0]), 340, 188);
        const props = { width, height, alt: title };
        const clickCountConfig = clickCount ? clickCount : '';

        if (isLazyImage) {
            props.src = imageUrl.normal;
            props['data-lazy-src'] = src;
        } else {
            props.src = src;
        }

        return (
            <figure className={styles.twoPic} data-list-item>
                {callUp ? (
                    <a
                        className={styles.twoPicItem}
                        onClick={this.handleClick.bind(this, url, id, newstype, kind, clickCountConfig, downloads)}>
                        <div className={styles.picBox}>
                            <img className={styles.pic} {...props} />
                            <time className={styles.time}>{formatTimeLength(length)}</time>
                        </div>
                        {callUp === 1 && (
                            <p className={styles.mark}>
                                <span className={styles.openApp}>打开APP阅读</span>
                            </p>
                        )}
                        <h2 className={styles.txt}>{title}</h2>
                    </a>
                ) : (
                    <a
                        onClick={this.feedClickCountFn.bind(this, clickCountConfig)}
                        className={styles.twoPicItem}
                        href={url}>
                        <div className={styles.picBox}>
                            <img className={styles.pic} {...props} />
                            {length && <time className={styles.time}>{formatTimeLength(length)}</time>}
                            {hasVideoIcon && <span className={styles.videoIcon} />}
                        </div>
                        <h2 className={styles.txt}>{title}</h2>
                    </a>
                )}
            </figure>
        );
    }
}

export default TwoImage;
